import React, { useState, useEffect } from 'react'
import { IonContent, IonPage } from '@ionic/react';
import LayoutGap from '../../layouts/LayoutGap';

import Toolbar from '../../layouts/Toolbar';
import { RouteComponentProps } from 'react-router';

import './Single.css'
import Description from '../campaigns/Description';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../redux/hooks';
import { PageAction } from '../../redux/actions/Home';
import LoadingContainer from '../../components/loading/LoadingContainer';

interface Props extends RouteComponentProps<{
    page: string
}> { }

const SinglePage: React.FC<Props> = ({ match }) => {
    const dispatch = useDispatch();
    const { loading, page } = useAppSelector(state => state.pageGet)

    useEffect(() => {
        dispatch(PageAction(match.params.page));
    }, [dispatch])

    return <LoadingContainer loading={loading}>
        <IonPage className="campaign-detail">
            <Toolbar title={page.title!} hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                <Description content={page.content!} />
            </IonContent>
        </IonPage>
    </LoadingContainer>
}

export default SinglePage